import React, { memo, useState } from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

const SelectDateContainer = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  height: 40px;
  padding: 0 15px;
  border-radius: 8px;
  border: 1px solid #725fed;
  background: #fff;
  cursor: pointer;
  transition: 0.2s;

  :hover {
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
      rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  }

  h6 {
    color: #725fed;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 130%;
  }
`;

const DateSelectorModalWindowWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 9999;
`;

const DateSelectorModalWindowContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: max-content;
  padding: 26px 24px;
  border-radius: 25px;
  background: #fff;
`;

const DateSelector = () => {
  const [openDatePickerModal, setOpenDatePickerModal] = useState(true);

  return (
    <div>
      <SelectDateContainer>
        <h6>15/01/2020</h6>
      </SelectDateContainer>

      {!openDatePickerModal &&
        createPortal(
          <DateSelectorModalWindowWrapper>
            <DateSelectorModalWindowContainer></DateSelectorModalWindowContainer>
          </DateSelectorModalWindowWrapper>,
          document.body
        )}
    </div>
  );
};

export default memo(DateSelector);
